<template>
<div class="chapter">
<div class="inner_page">
<div id="fm06">
<p class="auth">“And the woman was arrayed in purple and scarlet color, and decked with gold and precious stones and pearls, having a golden cup in her hand . . . And upon her forehead was a name written, MYSTERY, BABYLON . . . MOTHER OF HARLOTS AND ABOMINATIONS OF THE EARTH.”</p>
<p class="auth1">—S<span class="small">T.</span> J<span class="small">OHN THE</span> D<span class="small">IVINE</span>, <em class="italic">R<span class="small">EVELATION</span>,</em> 17:4-5</p>
<p class="auth2"><img alt="" class="figure" src="images/img_0002.jpg"/></p>
<p class="auth">“The most absurd thing is to be conscious of the fact that human existence is unbearable, that the human condition is unbearable—intolerable—and nevertheless cling to it.”</p>
<p class="auth1">—E<span class="small">UGENE</span> I<span class="small">ONESCO</span>, <em class="italic">M<span class="small">EMOIRS</span></em></p>
<p class="auth2"><img alt="" class="figure" src="images/img_0002.jpg"/></p>
<p class="auth">“What is truth? What is a lie?”</p>
<p class="auth1">—E<span class="small">VA</span> A<span class="small">DAMS</span>, <em class="italic">P<span class="small">ENSÉES</span></em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Comments.vue?874d84f8